import  { forwardRef } from 'react'
import '@styles/styles.modal.scss'
import {Sheet} from "react-modal-sheet";
import { useTheme } from '@hooks/useTheme';
import { ReactComponent as Cross } from "@assets/svg/close.svg";


const ModalMobile = forwardRef((props,ref) => {
        const { 
        children,
        backdrop=true,
        onClose,
        background="#F9FAFB",
        darkBackground="#000000",
        className,
        handleSnapChange,
        closable=true
        } = props
    
    const { theme, toggleTheme } = useTheme();
    

    return(
            <Sheet ref={ref} detent='content-height' {...props}>
                <Sheet.Container 
                 className={`sheet ${className}`}
                style={{backgroundColor:`${theme==="dark"?darkBackground:background}`}}>
                    <Sheet.Header onClick={handleSnapChange} />
                    <Sheet.Content >
                                {closable && <button
                                    className="absolute right-0 top-0 border-0 shadow-none bg-transparent z-10"
                                    onClick={onClose}>
                                    <Cross className="fill-black dark:fill-white"  height={28} width={28} />
                                </button>}
                        
                            {children}
                        
                    </Sheet.Content>
                </Sheet.Container>
                <Sheet.Backdrop className={backdrop?`backdrop`:`d-none `} onClick={onClose}/>
            </Sheet>
        
    );
})
export default ModalMobile